import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';

export class CardsRibbon extends View {
  private base: ImageScaleView;
  private text: LangBitmapFontTextView;

  constructor(opts: ViewOpts) {
    super({
      ...opts,
      width: 420,
      height: 73,
    });

    this.base = new ImageScaleView({
      superview: this,
      image: 'assets/ui/cards/common/ribbon.png',
      scaleMethod: '3slice',
      sourceSlices: {
        horizontal: { left: 80, right: 80 },
      },
      width: this.style.width,
      height: this.style.height,
      x: this.style.width / 2,
      y: this.style.height / 2,
      centerOnOrigin: true,
    });

    this.text = new LangBitmapFontTextView({
      superview: this,
      align: 'center',
      verticalAlign: 'center',
      size: 26,
      font: 'Title',
      color: '#FFFFFF',
      width: this.style.width - 30,
      height: this.style.height,
      centerOnOrigin: true,
      x: this.style.width / 2,
      y: this.style.height / 2 - 5,
    });
  }

  public setText(text: string) {
    this.text.localeText = () => text;
  }
}
